import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import BankSyncAllModal from 'Components/Banking/BankSyncAllModal';
import './BankTransactions.css';

export default function BankTransactions(props) {

	const x = props.x;

	const [reloadKey, setReloadKey] = React.useState(0);
	const [showSyncAll, setShowSyncAll] = React.useState(false);

	function afterSyncAll() {
		setShowSyncAll(false);
		setReloadKey((current) => current + 1);
	}

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="transactionid"
				x={x}
				classes="module-banking-transactions"
				tableClasses="banking-transactions-table"
				title={props.title}
				hideAddButton={true}
				module="Banking"
				listTask="BankingTransactionList"
				filterableColumns={['konto', 'counterpartyname', 'purpose', 'amount']}
				reloadKey={reloadKey}
				extraToolbar={
					<span
						className="bi bi-arrow-repeat module-icon"
						title="Umsätze aller Konten abrufen"
						onClick={() => setShowSyncAll(true)}
					></span>
				}
				onAddHeader={(addHeader) => {
					addHeader('Datum');
					addHeader('Konto');
					addHeader('Betrag');
					addHeader('Empfänger/Auftraggeber');
					addHeader('Verwendungszweck');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'transactionid':
						case 'valuedate':
						case 'currency':
						case 'bankreference':
						case 'counterpartyiban':
							return false;
						case 'bookingdate':
						case 'konto':
						case 'counterpartyname':
						case 'purpose':
							return value;
						case 'amount':
							return <span className={parseFloat(value) < 0 ? 'amount-negative' : 'amount-positive'}>{value} €</span>;
						default:
							return false;
					}
				}}
			/>
			{showSyncAll &&
				<BankSyncAllModal
					x={x}
					onClose={() => setShowSyncAll(false)}
					onSuccess={afterSyncAll}
				/>
			}
		</React.Fragment>
	)

};
